/**
 * This module is basically a no-op
 * @deprecated
 */

export function checkTokenExpiration(user) {
  return new Promise((resolve, reject) => { resolve({ status: 'success' }) });
}
